export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE_DISPLAY = "(678) 254-4892";
export const PHONE_LINK = "tel:6782544892";

export const fmtMoney = (n) =>
  `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;

export const IMAGES = {
  hero: "/images/hero.png",
  starter: "/images/starter.png",
  estate: "/images/estate.png",
  signature: "/images/signature.png",
};

export const PACKAGES = [
  {
    id: "starter",
    name: "Front Roof Line & Entryway",
    price: 599,
    deposit: 299.5,
    badge: "Cozy Classic",
    subtitle: "Your entire front roof line and front entry wrapped in warm light.",
    coverage: "Full front roof line + front door & entry arch + porch columns + walkway accents",
    included: [
      "Custom-cut commercial-grade C9 warm white LEDs",
      "Entire front roof line, precision clipped bulb-by-bulb",
      "Front door & entryway framed in light, lit wreath accent",
      "Porch columns wrapped in warm mini lights",
      "Walkway border stake lights to the sidewalk",
      "Heavy-duty digital timer (sunset to bedtime)",
      "All clips, cords, hardware & safety gear included",
      "48-hour bulb-out & storm repair, all season",
      "Early January full takedown & custom labeling",
    ],
    bestFor: "Bungalows, townhomes & single-story homes that want a clean, warm, festive welcome.",
    image: IMAGES.starter,
    gallery: [IMAGES.starter],
  },
  {
    id: "estate",
    name: "Estate Roofline & Windows",
    price: 999,
    deposit: 499.5,
    badge: "Most Popular",
    subtitle: "Roof line, gables, garage, entryway and every front window outlined in warm light.",
    coverage: "Full roof line + high gables + garage trim + entry arch + up to 8 front windows",
    included: [
      "Complete roof line including high gables & peaks",
      "Garage trim & carriage-door contouring in matching C9s",
      "Chimney & dormer accent outlining",
      "Front entryway arch, door columns & porch wrap",
      "Up to 8 front windows individually outlined",
      "Walkway & drive border stake lighting",
      "Automated sunset-to-midnight smart timer",
      "48-hour storm & bulb-out repair guarantee",
      "Mid-January meticulous takedown & spooling",
    ],
    bestFor: "Two-story colonial, craftsman & suburban homes that want street-stopping curb appeal.",
    image: IMAGES.estate,
    gallery: [IMAGES.estate],
  },
  {
    id: "signature",
    name: "The Signature Grand Estate",
    price: 1499,
    deposit: 749.5,
    badge: "Award-Winning Masterpiece",
    subtitle: "Everything lit: roof lines, dormers, windows, garage, shrubs, walkway and wrapped trees.",
    coverage: "Full roof lines & dormers + all windows + shrub nets + walkway + up to 3 wrapped trees",
    included: [
      "Full architectural roof line: 1st & 2nd stories, gables & dormers",
      "Every front window precision-outlined in warm C9s",
      "Garage, portico & entry canopy illumination",
      "Shrub & hedge net lighting across all front beds",
      "Trunk-to-canopy warm wraps on up to 3 small trees",
      "Walkway & driveway border lighting",
      "Statement greenery & lit wreath accents",
      "Smart Wi-Fi astronomical timer, app controlled",
      "Priority 24-hour bulb & storm repair, all season",
      "White-glove January takedown, labeled & boxed",
    ],
    bestFor: "Luxury estates & homeowners who want a postcard-perfect winter wonderland.",
    image: IMAGES.signature,
    gallery: [IMAGES.signature, IMAGES.hero],
  },
];

export const ADDON = {
  id: "storage_maintenance",
  name: "Climate-Controlled Storage & Annual Maintenance",
  price: 100,
  deposit: 50,
  description:
    "Skip the attic clutter. We inspect, clean, repair bulbs & fuses, spool, and store your custom strands in our temperature-controlled facility — ready for next November.",
};

export const MARQUEE_ITEMS = [
  "COMMERCIAL-GRADE C9 WARM LEDS",
  "100% TAKEDOWN INCLUDED",
  "ZERO LADDER RISK",
  "SOUTHERN CRAFTSMANSHIP",
  "48-HOUR SERVICE GUARANTEE",
  "ATLANTA & NORTH GEORGIA",
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Design & Custom Fit",
    body: "We measure every roofline, gable and window of your home and custom-cut commercial C9 strands to fit — no sagging loops, no guesswork.",
  },
  {
    num: "02",
    title: "White-Glove Installation",
    body: "Licensed, insured technicians install every bulb with precision clips and safety rigging. You never touch a ladder.",
  },
  {
    num: "03",
    title: "Mid-Season Bulb Warranty",
    body: "Storm knocks a strand loose? Our 48-hour service guarantee keeps your home glowing straight through New Year's.",
  },
  {
    num: "04",
    title: "January Takedown & Storage",
    body: "We return in January, remove everything, label every strand — and optionally store it all in our climate-controlled facility.",
  },
];

export const INSTALL_WINDOWS = ["Early November", "Mid November", "Late November", "Early December"];
